import { Sparkles } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useBeta } from '../../context/BetaContext';

/**
 * Bandeau de lancement Bêta avec compte à rebours de la période gratuite.
 * Ne rend rien si le mode Bêta est désactivé dans l'administration.
 *
 * La configuration vient de BetaContext : elle est lue une seule fois pour
 * toute l'application, ce qui évite que le bandeau, le badge et les routes
 * se désynchronisent pendant le chargement.
 */
const BetaBanner = () => {
    const { language } = useLanguage();
    const { betaConfig: config, betaEnabled, betaLoading } = useBeta();

    if (betaLoading || !betaEnabled || !config) {
        return null;
    }

    let daysLeft = null;
    if (config.endDate) {
        const diff = config.endDate.getTime() - Date.now();
        daysLeft = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
    }

    return (
        <div
            role="status"
            className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-cabaza-purple to-cabaza-pink"
        >
            <span className="px-2 py-0.5 text-xs font-bold uppercase bg-white/25 rounded-full">
                Bêta
            </span>
            <Sparkles className="w-4 h-4 flex-shrink-0" />
            <span>
                {config.message}
                {daysLeft !== null && ` ${config.endDate.toLocaleDateString(language)} (${daysLeft} j)`}
            </span>
        </div>
    );
};

export default BetaBanner;
